import React from 'react';

const SvgMathExponent = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M3.5 8l4.6 6-4.6 6h2.8l3.2-4.1 3.2 4.1h2.8l-4.6-6 4.6-6h-2.8l-3.2 4.1L6.3 8H3.5zM18.5 7.6L19.7 4h1.8L19 11l-.1.3c-.5 1.2-1.6 1.7-3.3 1.6v-1.3c1.8 0 2.1-1.1 2.1-1.3l.1-.2-2.2-6h1.8l1.1 3.5z" />
  </svg>
);

export default SvgMathExponent;
